import * as React from 'react';
import GameBoard from './GameBoard';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import './MainBatuLagi.css';
import { MutableRefObject, useMemo, useRef, useState } from 'react';
import { Game } from './Game';

type Move = { start: number, end: number};

const MainBatuLagi = () => {
    const MAXN = 10;
    const MAXM = 10;

    const [input, setInput] = useState('5 2\n1 1\n1 2\n1 3\n4 4\n3 5');
    const [message, setMessage] = useState('');
    const textareaRef = useRef() as MutableRefObject<HTMLTextAreaElement>;
    
    const game = useMemo(() => new Game([0, 1, 2, 3, 4], [
        {start: 0, end: 0},
        {start: 0, end: 1},
        {start: 0, end: 2},
        {start: 3, end: 3}
    ], [2, 4]), []);

    const generateGame = (config: string) => {
        const lines = config.split('\n');
        try {
            const [N, M]:number[] = lines[0].split(/ +/).map(s => parseInt(s));
            if(!(1 <= N && N <= MAXN) || !(1 <= M && M <= MAXM)) throw new Error("1 <= N, M <= 100");
            
            const boxes: number[] = [0];
            const moves: Move[] = [];
            for(let i = 1; i < N; i++){
                boxes.push(i);
                let [start, end] = lines[i].split(/ +/).map(s => parseInt(s));
                start--;
                end--;
                if(!(0 <= start && start <= end && end < i)) throw new Error("Constraint 4 violated");
                
                moves.push({ start, end });
            }
            
            for(let i = 1; i < N - 1; i++){
                if(!(moves[i - 1].start <= moves[i].start && moves[i - 1].end <= moves[i].end)) throw new Error("Constraint 5 violated");
            }
            
            const pawnPosition: number[] = lines[N].split(/ +/).map(s => parseInt(s) - 1);
            if(pawnPosition.length !== M) throw new Error("Incorrect number of pawn");
            for(let i = 0; i < M; i++){
                if(!(0 <= pawnPosition[i] && pawnPosition[i] < N)) throw new Error("Pawn is outside the box");
            }
            game.setNewGame(boxes, moves, pawnPosition);
            setMessage('OK');
        }
        catch(error){
            if(error.message.length === 0) setMessage('Wrong input format or constraint');
            else setMessage(error.message);
        }
    }

    const generateRandomGame = () => {
        const [N, M]: number[] = [Math.floor(Math.random() * MAXN) + 1, Math.floor(Math.random() * MAXM) + 1];
        const boxes: number[] = [0];
        const moves: Move[] = [];

        let startBefore: number = 0;
        let endBefore: number = 0;
        for(let i = 1; i < N; i++){
            boxes.push(i);
            let start = Math.floor(Math.random() * (i - startBefore)) + startBefore;
            let end = Math.floor(Math.random() * (i - Math.max(start, endBefore))) + Math.max(start, endBefore);
            moves.push({start, end});
            [startBefore, endBefore] = [start, end];
        }

        const pawnPosition: number[] = [];
        for(let i = 0; i < M; i++){
            pawnPosition.push(Math.floor(Math.random() * N));
        }

        game.setNewGame(boxes, moves, pawnPosition);
        const configString = `${N} ${M}\n${moves.map(({start, end}) => `${start + 1} ${end + 1}\n`).join('')}${pawnPosition.map(p => (p + 1).toString()).join(' ')}\n`;
        textareaRef.current.value = configString;
    }
    
    return (
        <div className='main-batu-lagi'>
            <div>This is a visualization for <a target='_blank' rel='noreferrer noopener' href='https://tlx.toki.id/problems/compfest-2014-scp-penyisihan/D'>this game</a></div>
            <div className='game-container'>
                <div className='game-config'>
                    Enter custom game
                    <div className='input'>
                        <textarea ref={textareaRef} defaultValue={`${input}`} onInput={(event) => setInput((event.target as HTMLInputElement).value)}></textarea>
                        <div>
                            <button onClick={() => generateGame(input)}>Generate</button>
                            <button onClick={() => generateRandomGame()}>Random</button>
                        </div>
                    </div>
                    <div>{message}</div>
                </div>
                <div className='board-container'>
                    <DndProvider backend={HTML5Backend}>
                        <GameBoard key={0} game={game}/>
                    </DndProvider>
                </div>
            </div>
        </div>
    );
}

export default MainBatuLagi;